import React from 'react';
import { Counter } from '../common/Counter';
import type { StatsCardItem } from '../../types/dashboard';
import { getDashboardCardColors } from '../../utils';
import { Tooltip } from '@radix-ui/themes';
import { InfoCircle } from 'iconoir-react';

interface StatsCardProps {
  item: StatsCardItem;
  // Jun-16 (a user V1 test, D4): optional click target so a stat tile (e.g.
  // "High compatibility") can navigate instead of being a dead indicator.
  onClick?: () => void;
}

const StatsCard = ({ item, onClick }: StatsCardProps) => {
  return (
    // Deliberately NOT a <button>: the card already contains the tooltip's own
    // button, and a button inside a button is invalid HTML that browsers
    // silently restructure. role + tabIndex + a key handler is the correct
    // shape here, and only applied when the card is actually clickable, so a
    // static card is not announced as an interactive control.
    <div
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      className={`px-4 sm:px-6 py-5 text-white rounded-xl ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''} ${getDashboardCardColors(item.title)}`}
    >
      <div className='flex items-center justify-between mb-1'>
        <p className='font-medium inline-flex items-center sm:text-base text-[13px] pe-3 sm:pe-0'>
          {item.title}
          {item?.info && (
            <Tooltip content={item.info}>
              <button
                type='button'
                className='inline-flex items-center justify-center ml-2 p-1.5 -my-1.5 focus:outline-none'
                aria-label='More information'
              >
                <InfoCircle className='w-5 h-5 text-white/80 hover:text-white transition-colors' />
              </button>
            </Tooltip>
          )}
        </p>
        {item.icon}
      </div>
      <h2 className='!font-medium mb-0'>
        <Counter value={item.value} />{item.isPercentage && '%'}
      </h2>
    </div>
  );
};

export default StatsCard;
